import { ref } from 'vue';
import router from '@/router/index.js';
export default {
  name: 'ttNavHeader',
  props: {
    title: {
      type: String,
      value: '天天悦读'
    }
  },
  setup() {
    let isapp = ref(window.VideoJsBridge ? true : false);

    /**
    * @description: 返回
    * @return {*}
    */
    const goBack = () => {
      router.go(-1);
    };
    return {
      isapp,
      goBack
    };
  }
};